import type { HelpFile } from '../../types/help'
import { TableEmptyStateTestIds } from '../../../testids/TableEmptyStateTestIds'

export const tableEmptyStateHelp: HelpFile = {
  texts: {
    [TableEmptyStateTestIds.tableEmptyState]: 'Keine Zeilen entsprechen den aktuellen Filtern oder es existieren noch keine Daten.',
  },
}
